<template>
  <div class="div-body">
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" :show-close="false">
      <div class="body-dialog">
        <div class="icon-alert animate__animated animate__rotateInDownLeft">
          <div class="icon-alert-content">i</div>
        </div>
        <h5 class="title mb-0">
          Tài khoản của quý khách chưa tham gia chương trình khách hàng thân thiết,
          vui lòng truy cập ứng dụng Quản trị và Kinh doanh Du lịch thực hiện ký hợp đồng để có thể sử dụng tính năng này.
          Để tải ứng dụng, vui lòng tải tại
          <a :href="DataService.urlDownloadAppTourGuideIOS" target="_blank">AppStore</a>
          hoặc
          <a :href="DataService.urlDownloadAppTourGuideCHPlay" target="_blank">CH Play</a>
          , hoặc quét mã QR.
        </h5>
        <div class="qr-app text-center">
          <el-image src="img/qr-app-hdv.jpg" fit="cover" class="qr-app-img"></el-image>
        </div>
      </div>
    </el-dialog>
    <!-- Start Giảm giá -->
    <div class="card-body" v-if="isBankClientSigned">
      <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
        <b-row class="mt-2">
          <b-col md="12">
            <b-card>
              <div slot="header">
                Giảm giá
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapseUuDaiKDL v-b-tooltip.hover
                    :title="aLang.c_toggle">
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>

              <b-collapse id="collapseUuDaiKDL" visible>
                <p class="mb-0">Ưu đãi khi thanh toán bằng <span class="bold card__du-lich" @click="gotoNewPage">Thẻ
                    du lịch</span> trên tổng hóa đơn* </p>
                <b-row>
                  <b-col md="4">
                    <el-form-item v-if="showSelectKDL" label="Loại hình ưu đãi" prop="thong_tin_chung.loai_hinh_uu_dai">
                      <el-select v-model="mData.dataForm.thong_tin_chung.loai_hinh_uu_dai"
                        placeholder="Chọn loại hình ưu đãi" clearable @change="changeTypeEndowKDL()"
                        @clear="clearTypeEndowKDL()" @blur="validateFieldMethod(`thong_tin_chung.loai_hinh_uu_dai`)"
                        @input="forceUpdateUI">
                        <el-option v-for="item in mData.dataDefault.listLoaiHinhUuDai" :key="item.value"
                          :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="4" v-if="mData.dataForm.thong_tin_chung.loai_hinh_uu_dai == 'giam_gia_tien'">
                    <el-form-item v-if="showMoneyElementUI" label="Giá trị ưu đãi (VND)"
                      prop="thong_tin_chung.gia_tri_uu_dai">
                      <ElementUiMoney v-model="mData.dataForm.thong_tin_chung.gia_tri_uu_dai" label=""
                        :placeholder="'Nhập giá trị ưu đãi'" :outlined="true" :clearable="true" :options="options1"
                        @input="forceUpdateUI()" :refProp="`thong_tin_chung.gia_tri_uu_dai`"
                        @blurInput="validateFieldMethod('thong_tin_chung.gia_tri_uu_dai')" />
                    </el-form-item>
                  </b-col>
                  <b-col md="4" v-if="mData.dataForm.thong_tin_chung.loai_hinh_uu_dai == 'giam_gia_phan_tram'">
                    <el-form-item v-if="show" label="Giá trị ưu đãi (%)" prop="thong_tin_chung.gia_tri_uu_dai">
                      <el-input v-model="mData.dataForm.thong_tin_chung.gia_tri_uu_dai" type="number"
                        placeholder="Nhập giá trị ưu đãi"
                        @change="changeShowInput(mData.dataForm.thong_tin_chung.gia_tri_uu_dai, 'mData.dataForm.thong_tin_chung.gia_tri_uu_dai')"
                        @input="forceUpdateUI()"></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-card>
          </b-col>
        </b-row>
        <!-- Start chiết khấu -->
        <b-row class="mt-2">
          <b-col md="12">
            <b-card>
              <div slot="header">
                Chiết khấu
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapseUuDaiHDV v-b-tooltip.hover
                    :title="aLang.c_toggle">
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>

              <b-collapse id="collapseUuDaiHDV" visible>
                <b-row>
                  <b-col md="4">
                    <el-form-item v-if="showSelectHDV" label="Loại hình ưu đãi"
                      prop="thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai">
                      <el-select v-model="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai"
                        placeholder="Chọn loại hình ưu đãi" clearable @change="changeTypeEndowHDV()"
                        @blur="validateFieldMethod(`thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai`)"
                        @input="forceUpdateUI" @clear="clearTypeEndowHDV()">
                        <el-option v-for="item in mData.dataDefault.listLoaiHinhUuDai" :key="item.value"
                          :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="4"
                    v-if="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai == 'giam_gia_tien'">
                    <el-form-item v-if="showMoneyElementUI" label="Giá trị ưu đãi (VND)"
                      prop="thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai">
                      <ElementUiMoney v-model="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai"
                        label="" :placeholder="'Nhập giá trị ưu đãi'" :outlined="true" :clearable="true"
                        :options="options1" @input="forceUpdateUI()"
                        :refProp="`thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai`"
                        @blurInput="validateFieldMethod('thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai')" />
                    </el-form-item>
                  </b-col>
                  <b-col md="4"
                    v-if="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai == 'giam_gia_phan_tram'">
                    <el-form-item v-if="show" label="Giá trị ưu đãi (%)"
                      prop="thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai">
                      <el-input v-model="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai"
                        type="number" placeholder="Nhập giá trị ưu đãi"
                        @change="changeShowInput(mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai, 'mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai')"
                        @input="forceUpdateUI()"></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-card>
          </b-col>
        </b-row>

        <el-form-item class="text-center mt-3">
          <el-button type="info" plain @click="fn_updateEndowHDV()" v-ladda
            v-if="mData.dataForm.isActive && hasPermissionEditData">Cập nhật ưu đãi</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import DataService from '../../../service/DataService'
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ElementUiMoney from '@/component/ElementUiMoney';
import ShareDuLieuKhaiBaoModel from '@/views/admin/ShareModel/ShareDuLieuKhaiBaoModel';
import ShareThongTinChungModel from '@/views/admin/ShareModel/ShareThongTinChungModel';
import Swal from 'sweetalert2'
import 'animate.css'
import DDATApi from "../../../moduleApi/DDATApi";
import DonViCungCapApi from '@/moduleApi/DonViCungCapApi';
import DonViCungCapChoDuyetApi from '@/moduleApi/DonViCungCapChoDuyetApi';

import DDATModel from "@/views/admin/DDAT/DDATModel";

export default {
  components: {
    ElementUiMoney,
  },
  data() {
    return {
      dialogVisible: false,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      DataService: DataService,
      show: true,
      showSelectHDV: true,
      showSelectKDL: true,
      showMoneyElementUI: true,
      hasPermissionEditData: true,
      currentUser: '',
      isBankClientSigned: false,

      options1: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 100,
        precision: 0,
      },

      mData: {
        moduleName: "ThongTinDDAT2", //required
        isActive: true,
        notAllowToChange: false,
        tableRules: MethodService.copyObject(DDATModel.tableRules),
        dataForm: {
          hoat_dong: {
            ngung_hoat_dong: undefined
          },
          du_lieu_khai_bao: MethodService.copyObject(ShareDuLieuKhaiBaoModel),
          thong_tin_chung: MethodService.copyObject(ShareThongTinChungModel.dataForm),
        },
        validForm: DDATModel.validForm,
        dataFormNew: MethodService.copyObject(DDATModel.dataForm),

        dataDefault: {
          listLoaiHinhUuDai: [
            {
              value: "giam_gia_tien",
              label: "Giảm giá tiền"
            },
            {
              value: "giam_gia_phan_tram",
              label: "Giảm giá phần trăm"
            }
          ],
          listLoaiHinhVe: [
            {
              value: "air_plain_ticket",
              label: 'Vé máy bay'
            },
            {
              value: "show_ticket",
              label: 'Vé nghệ thuật biểu diễn'
            },
            {
              value: "transport_ticket",
              label: 'Vé giao thông'
            }
          ],
        }
      },
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },

    showAlert() {
      Swal.fire({
        icon: 'info',
        html:
          `Chức năng được phát triển trên ứng dụng Quản trị và Kinh doanh Du lịch. Để tải ứng dụng vui lòng tải tại ` +
          `<a href="${DataService.urlDownloadAppTourGuideIOS}" target="_blank">AppStore</a> ` +
          `hoặc <a href="${DataService.urlDownloadAppTourGuideCHPlay}" target="_blank">CH Play</a> , hoặc quét mã QR!`
      })
    },

    gotoNewPage() {
      window.open("http://thedulich.gov.vn/", '_blank').focus();
    },

    //get data
    async fn_initData() {
      let dataFilter = {
        filters: "nguoi_tao_id=" + this.currentUser.id,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      // if (this.mData.tableRules.showUrl) {
      //   this.$router.replace({
      //     name: "Admin-" + this.mData.moduleName + "-detail"
      //   }).catch(() => { });
      // }
      let res = await DDATApi.list(dataFilter);
      if (res.result) {
        this.mData.dataFormNew = res.result[0];
        let donViCungCapRes = await DonViCungCapApi.findById(
          res.result[0].id
        );
        if (donViCungCapRes.result) {
          this.mData.dataForm = donViCungCapRes.result;
          this.mData.dataForm.thong_tin_chung = {
            huong_dan_vien: {
              uu_dai: {
                loai_hinh_uu_dai: undefined,
                gia_tri_uu_dai: undefined,
              }
            }
          }
          // Check bank client is signed
          this.isBankClientSigned = false;

          if (
            res.result[0] &&
            res.result[0].bankClient &&
            res.result[0].bankClient.signed &&
            res.result[0].bankClient.id &&
            res.result[0].bankClient.key
          ) {
            this.isBankClientSigned = true;
          } else {
            setTimeout(() => {
              this.dialogVisible = true
              // this.showAlert()
            }, 1000 * 0.7);
          }

          if (donViCungCapRes.result.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai) {
            this.mData.validForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai = [ValidService.required]
          }
          if (donViCungCapRes.result.thong_tin_chung.loai_hinh_uu_dai) {
            this.mData.validForm.thong_tin_chung.gia_tri_uu_dai = [ValidService.required]
          }
          if (res.result[0].hoat_dong == undefined || res.result[0].hoat_dong.ngung_hoat_dong == undefined) {
            this.mData.dataForm.hoat_dong = { ngung_hoat_dong: false }
          }
          else {
            this.mData.dataForm.hoat_dong = res.result[0].hoat_dong;
            // this.mData.dataForm.hoat_dong.ngung_hoat_dong =  true;
          }
          if (res.result[0].hoat_dong == undefined || res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi == undefined) {
            this.mData.notAllowToChange = false;
          } else {
            let todayTime = new Date().getTime();
            let lastTimeChange = new Date(res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi).getTime();
            let totalTimeChange = (todayTime - lastTimeChange) / 1000 / 60 / 60 / 24;

            if (totalTimeChange < 7) {
              this.mData.notAllowToChange = true;
            } else {
              this.mData.notAllowToChange = false;
            }
          }

          if (this.mData.dataForm.hoat_dong.ngung_hoat_dong) {
            this.mData.dataForm.isActive = false;
          } else {
            this.mData.dataForm.isActive = true;
          }
        } else {
          const donViCungCapChoDuyetRes = await DonViCungCapChoDuyetApi.findById(
            res.result[0].id
          )
          if (donViCungCapChoDuyetRes.result) {
            this.mData.dataForm = donViCungCapChoDuyetRes.result;
            this.mData.dataForm.thong_tin_chung = {
              huong_dan_vien: {
                uu_dai: {
                  loai_hinh_uu_dai: undefined,
                  gia_tri_uu_dai: undefined,
                }
              }
            }
            if (res.result[0].hoat_dong == undefined || res.result[0].hoat_dong.ngung_hoat_dong == undefined) {
              this.mData.dataForm.hoat_dong = { ngung_hoat_dong: false };
            }
            else {
              this.mData.dataForm.hoat_dong = res.result[0].hoat_dong;
            }
            if (res.result[0].hoat_dong == undefined || res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi == undefined) {
              this.mData.notAllowToChange = false;
            } else {
              let todayTime = new Date().getTime();
              let lastTimeChange = new Date(res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi).getTime();
              let totalTimeChange = (todayTime - lastTimeChange) / 1000 / 60 / 60 / 24;

              if (totalTimeChange < 7) {
                this.mData.notAllowToChange = true;
              } else {
                this.mData.notAllowToChange = false;
              }
            }

            if (this.mData.dataForm.hoat_dong.ngung_hoat_dong) {
              this.mData.dataForm.isActive = false;
            } else {
              this.mData.dataForm.isActive = true;
            }
          }
        }

        this.showSelect = false;
        if (!res.result[0].thong_tin_chung.huong_dan_vien) {
          this.mData.dataForm.thong_tin_chung = {
            huong_dan_vien: {
              uu_dai: {
                loai_hinh_uu_dai: undefined,
                gia_tri_uu_dai: undefined,
              }
            }
          }
        } else if (
          res.result[0].thong_tin_chung.huong_dan_vien.uu_dai &&
          (res.result[0].thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai || res.result[0].thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai)
        ) {
          this.checked = true;
          this.mData.dataForm.thong_tin_chung = {
            huong_dan_vien: {
              uu_dai: {
                loai_hinh_uu_dai: res.result[0].thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai,
                gia_tri_uu_dai: res.result[0].thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai
              }
            }
          }
        }
        this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai = res.result[0].thong_tin_chung.loai_hinh_uu_dai ? res.result[0].thong_tin_chung.loai_hinh_uu_dai : undefined;
        this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = res.result[0].thong_tin_chung.gia_tri_uu_dai ? res.result[0].thong_tin_chung.gia_tri_uu_dai : undefined;
      }
      setTimeout(() => {
        this.showSelect = true;
      }, 10);
    },

    checkPermission() {
      if (
        this.currentUser.roles.includes("SafePlace")
        && this.mData.dataForm.loai == "ticket"
        && this.mData.dataForm.ve_dien_tu
        && this.mData.dataForm.ve_dien_tu.loai
        && (this.mData.dataForm.ve_dien_tu.loai.includes("air_plain_ticket") || this.mData.dataForm.ve_dien_tu.loai.includes("transport_ticket"))
      ) {
        this.hasPermissionEditData = false;
      }
    },

    changeTypeEndowKDL() {
      if (!this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai) return
      // this.mData.validForm.thong_tin_chung.gia_tri_uu_dai = [ValidService.required]
      this.showSelectKDL = false;
      this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = undefined;
      setTimeout(() => {
        this.showSelectKDL = true;
      }, 1)
    },

    clearTypeEndowKDL() {
      this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai = undefined
      this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = undefined
      this.mData.validForm.thong_tin_chung.gia_tri_uu_dai = []
    },

    validateFieldMethod(prop) {
      this.$refs['myForm'].validateField(prop)
      if (
        prop == 'thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai' ||
        prop == 'thong_tin_chung.gia_tri_uu_dai'
      ) {
        this.showMoneyElementUI = false
        setTimeout(() => {
          this.showMoneyElementUI = true
        }, 10)
      }
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },

    changeShowInput(data, field) {
      if (!data) return
      this.show = false
      if (parseInt(data) > 100) {
        if (field == 'mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai')
          this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai = '100'
        if (field == 'mData.dataForm.thong_tin_chung.gia_tri_uu_dai')
          this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = '100'
      } else if (parseInt(data) === 0) {
        if (field == 'mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai')
          this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai = undefined
        if (field == 'mData.dataForm.thong_tin_chung.gia_tri_uu_dai')
          this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = undefined
      }
      setTimeout(() => {
        this.show = true
      }, 10)
    },

    changeTypeEndowHDV() {
      if (!this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai) return
      // this.mData.validForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai = [ValidService.required]
      this.showSelectHDV = false;
      this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai = undefined;
      setTimeout(() => {
        this.showSelectHDV = true;
      }, 1)
    },

    clearTypeEndowHDV() {
      this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai = undefined
      this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai = undefined
      this.mData.validForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai = []
    },

    changeTypeEndowKDL() {
      if (!this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai) return
      // this.mData.validForm.thong_tin_chung.gia_tri_uu_dai = [ValidService.required]
      this.showSelectKDL = false;
      this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = undefined;
      setTimeout(() => {
        this.showSelectKDL = true;
      }, 1)
    },

    fn_updateEndowHDV() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          console.log('this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai', this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai);
          console.log('this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai', this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai);
          if (!this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai) this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai = undefined
          if (!this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai) this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai = undefined
          let dataUuDaiHDv = {
            id: this.mData.dataFormNew.id,
            loai_hinh_uu_dai: this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai,
            gia_tri_uu_dai: this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai
              ? parseFloat(this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai)
              : undefined
          };
          let dataUuDai = {
            id: this.mData.dataFormNew.id,
            loai_hinh_uu_dai: this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai,
            gia_tri_uu_dai: this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai
              ? parseFloat(this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai)
              : undefined
          };
          try {
            await DDATApi.updateUuDai(dataUuDai);
            await DDATApi.updateHdvUuDai(dataUuDaiHDv);
            this.fn_initData();
          } catch (error) {
            console.info(error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
  },

  created() {
    this.currentUser = MethodService.getCurrentUser();
  },

  async mounted() {
    await this.fn_initData();
    await this.checkPermission();
  },
}
</script>
<style lang="scss" scoped>
.div-body {
  height: calc(100vh - 106px);
  background: #fff;
}

::v-deep .el-dialog {
  border-radius: 5px;
  width: 500px;
  padding: 10px 15px;
  margin-top: 12vh !important;

  .el-dialog__header {
    padding: 0;
    border: none;
  }

  .el-dialog__body {
    border-radius: 5px;
    background: #fff;
    color: #545454;
    max-height: calc(100vh - 140px);
    overflow: auto;
  }
}

.body-dialog {
  padding: 10px 15px;
  word-break: break-word;
  white-space: inherit;
  text-align: center;

  .icon-alert {
    position: relative;
    box-sizing: content-box;
    justify-content: center;
    width: 5em;
    height: 5em;
    border: 0.25em solid transparent;
    border-radius: 50%;
    border-color: #000;
    font-family: inherit;
    line-height: 5em;
    cursor: default;
    border-color: #70d0f0;
    color: #3fc3ee;
    margin: 0 auto;

    .icon-alert-content {
      font-size: 60px;
    }
  }

  .title {
    margin-top: 10px;
    text-align: center;
    font-weight: 400;
    line-height: normal;
  }

  .qr-app-img {
    width: 350px;
    height: 350px;
  }
}

@media (max-width: 550px) {
  ::v-deep .el-dialog {
    width: 310px;
    margin-top: 10vh !important;
  }

  .body-dialog {
    .qr-app-img {
      width: 250px;
      height: 250px;
    }
  }
}
</style>
